import type { AccessGateway } from './accessGateway';
import {
  normalizeInvitationCredentials,
  validateInvitationCredentials,
  type AccessResult,
  type InvitationCredentials,
} from '../domain/access';

export async function beginFounderAccess(
  gateway: AccessGateway,
  signal?: AbortSignal,
): Promise<AccessResult> {
  return gateway.beginFounderAccess(signal);
}

export async function verifyFounderCode(
  gateway: AccessGateway,
  code: string,
  signal?: AbortSignal,
): Promise<AccessResult> {
  const normalized = code.trim();

  if (!/^\d{6,10}$/u.test(normalized)) {
    return {
      ok: false,
      error: {
        code: 'IDENTITY_REJECTED',
        message: 'Escribe el código numérico recibido por correo.',
      },
    };
  }

  if (gateway.verifyFounderCode === undefined) {
    return {
      ok: false,
      error: {
        code: 'IDENTITY_UNAVAILABLE',
        message: 'Este entorno no admite verificación por código.',
      },
    };
  }

  return gateway.verifyFounderCode(normalized, signal);
}

export async function redeemInvitation(
  gateway: AccessGateway,
  credentials: InvitationCredentials,
  signal?: AbortSignal,
): Promise<AccessResult> {
  const validationError = validateInvitationCredentials(credentials);

  if (validationError !== null) {
    return { ok: false, error: validationError };
  }

  return gateway.redeemInvitation(
    normalizeInvitationCredentials(credentials),
    signal,
  );
}

export async function resumePendingAccess(
  gateway: AccessGateway,
  signal?: AbortSignal,
): Promise<AccessResult | null> {
  if (gateway.resumePendingAccess === undefined) {
    return null;
  }

  return gateway.resumePendingAccess(signal);
}
